import { useEffect, useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from "./ui/dialog";
import api from "../lib/api";

export default function SizeGuideDialog({ open, onOpenChange }) {
  const [chart, setChart] = useState(null);

  useEffect(() => {
    if (!open || chart) return;
    api.get("/storefront/settings")
      .then((r) => setChart(r.data.size_chart))
      .catch(() => {});
  }, [open, chart]);

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-2xl bg-cream-50 border-blush-100 rounded-3xl" data-testid="size-guide-dialog">
        <DialogHeader>
          <DialogTitle className="font-heading text-3xl text-ink-900">Size guide</DialogTitle>
          <DialogDescription className="font-body text-ink-500">
            All measurements in {chart?.unit === "cm" ? "centimetres" : "inches"}. Sizes are a gentle reference — fabric, fit, and movement vary across pieces.
          </DialogDescription>
        </DialogHeader>
        {!chart ? (
          <div className="py-10 text-center text-ink-500 font-script text-2xl">loading…</div>
        ) : (
          <div className="overflow-x-auto rounded-xl border border-blush-100 mt-2">
            <table className="w-full text-sm font-body">
              <thead>
                <tr className="bg-blush-50/60 text-[11px] uppercase tracking-[0.18em] text-ink-500">
                  <th className="px-4 py-3 text-left">Size</th>
                  <th className="px-4 py-3">Bust</th>
                  <th className="px-4 py-3">Waist</th>
                  <th className="px-4 py-3">Hip</th>
                  <th className="px-4 py-3">Length</th>
                </tr>
              </thead>
              <tbody>
                {(chart.rows || []).map((row, i) => (
                  <tr key={i} className="border-t border-blush-100">
                    <td className="px-4 py-3 text-blush-600 font-medium">{row.size}</td>
                    <td className="px-4 py-3 text-center">{row.bust}</td>
                    <td className="px-4 py-3 text-center">{row.waist}</td>
                    <td className="px-4 py-3 text-center">{row.hip}</td>
                    <td className="px-4 py-3 text-center">{row.length}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
        <p className="mt-4 text-[11px] font-body text-ink-500 leading-relaxed">
          <strong className="text-ink-900">How to measure:</strong> use a soft measuring tape. Keep it snug, not tight. Bust is the fullest part; waist at the natural indentation; hip at the widest point.
        </p>
      </DialogContent>
    </Dialog>
  );
}
